import infoBlockSearchPath from 'assets/img/info-block-search.png';
import infoBlockSentPath from 'assets/img/info-block-sent.png';
import infoBlockUploadPath from 'assets/img/info-block-upload.png';

export const infoBlockCards = [
  {
    step: '01',
    title: 'Дождитесь поиска реквизитов',
    pathImg: infoBlockSearchPath,
  },
  {
    step: '02',
    title: 'Отправьте \n указанную сумму',
    pathImg: infoBlockSentPath,
  },
  {
    step: '03',
    title: 'Загрузите \n чек об оплате',
    pathImg: infoBlockUploadPath,
  },
];
